import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import propTypes from '@styled-system/prop-types';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { backgroundColor, border, color, layout, position, shadow, space, textStyle, typography, variant } from 'styled-system';
export const Button = styled.button.withConfig({
  displayName: "Button",
  componentId: "sc-j1txxp-0"
})(["&&&{border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;font-weight:900;padding-top:2px;:disabled{pointer-events:none;}", " ", " :disabled{", "}", " ", " ", " ", " ", " ", " ", " ", "}"], variant({
  variants: {
    primary: {
      color: 'brandLight',
      backgroundColor: 'accent.shape',
      borderRadius: '5',
      width: '100%',
      lineHeight: '4',
      boxShadow: '1',
      ':disabled': {
        backgroundColor: 'background.grainsboro',
        color: 'text.caption',
        boxShadow: 'none'
      }
    },
    outline: {
      color: 'accent.shape',
      backgroundColor: 'brandLight',
      borderRadius: '5',
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: 'accent.shape',
      width: '100%',
      lineHeight: '4',
      ':disabled': {
        backgroundColor: 'brandLight',
        borderColor: 'text.caption',
        color: 'text.caption'
      }
    },
    secondary: {
      color: 'text.primary',
      backgroundColor: 'brandLight',
      borderRadius: '5',
      width: '100%',
      lineHeight: '4',
      boxShadow: '6',
      ':disabled': {
        backgroundColor: 'background.grainsboro',
        color: 'text.caption',
        boxShadow: 'none'
      }
    },
    text: {
      backgroundColor: 'transparent',
      lineHeight: '3',
      padding: '6px 12px',
      ':disabled': {
        opacity: '0.4'
      }
    },
    round: {
      color: 'text.primary',
      backgroundColor: 'background.spaceWhite',
      borderRadius: '7',
      boxShadow: '1',
      ':disabled': {
        backgroundColor: 'background.grainsboro',
        color: 'text.caption',
        boxShadow: 'none'
      }
    },
    square: {
      color: 'text.primary',
      backgroundColor: 'background.spaceWhite',
      borderRadius: '0',
      width: '1',
      boxShadow: 'none',
      ':disabled': {
        color: 'text.caption'
      }
    }
  }
}), variant({
  prop: 'size',
  variants: {
    small: {
      width: '36px',
      height: '36px',
      lineHeight: '36px'
    },
    medium: {
      width: '46px',
      height: '46px',
      lineHeight: '48px'
    }
  }
}), color, border, space, color, typography, textStyle, shadow, layout, position);
Button.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
  variant: PropTypes.oneOf(['primary', 'secondary', 'text', 'round']),
  size: PropTypes.oneOf(['small', 'medium'])
}, propTypes.buttonStyle), propTypes.color), propTypes.border), propTypes.space), propTypes.typography), propTypes.textStyle), propTypes.layout);
Button.defaultProps = {
  fontSize: [3, 3, 4],
  variant: 'primary',
  'aria-label': 'description'
};